function elementsOverlap(el1, el2) {
  const domRect1 = $(el1)[0].getBoundingClientRect();
  const domRect2 = $(el2)[0].getBoundingClientRect();

  return !(
    domRect1.top > domRect2.bottom ||
    domRect1.right < domRect2.left ||
    domRect1.bottom < domRect2.top ||
    domRect1.left > domRect2.right
  );
}

function updateTopProductGallery() {
    if (jQuery('.t-product').length) {
        let announcementbar = 0;
        let headerContent = 0
        if (jQuery('.header_container .announcement-bar').length){
            announcementbar = jQuery('.header_container .announcement-bar').outerHeight();
        }
        if (jQuery('.header_container .header-inner').length){
            headerContent = jQuery('.header_container .header-inner').outerHeight();
        }
        if (jQuery(window).width() >= 778) {
            jQuery('.t-product .product-page .item.pv1 .slider-media-container').css('top', (headerContent + announcementbar + 50) + 'px' )
        } else {
            jQuery('.t-product .product-page .item.pv1 .slider-media-container').removeAttr('style');
        }
    }
}

$(document).ready(function () {
    updateTopProductGallery();

  
  // create fake select variant
  $('.variant-selected, .variant-slted').click(function() {
    $(this).toggleClass('active').next().slideToggle(250);
  })
  $('.t-product #buyplatform .select-variants .variants .variant').click(function() {
    var val   = $(this).attr('variant-val');
    var id    = $(this).attr('data-id');
    var price = $(this).attr('variant-price');
    $('.t-product #buyplatform .select__select').val(val).trigger('change');
    $('.t-product #buyplatform .variant-selected .value').text(val);
    $('.t-product #buyplatform [name=id]').val(id);
    $(this).parent().slideUp(250).prev().removeClass('active');
    $('.t-product #buyplatform .cartButton.is-primary .price').text(price)
    $('.t-product .product-page .product-heading .col-right .price').text(price)
  });
  


  //create fake select variant for related products
  $('.related-product-select .variant').click(function() {
    var val = $(this).attr('data-id')
    var text = $(this).text()
    $(this).parent().prev().find('.label').text(text).closest('.select-variants').next().val(val)
    if ($(this).closest('.select-variants').next().val()) {
      $(this).closest('form').find('button[type=submit]').click()
    }
  })
  
  $('.select-variants.not-select .variant').click(function(){
      $(this).addClass('selected');
      $(this).siblings().removeClass('selected');
  })

  $('body').click(function() {
    $('.t-product #buyplatform .variants').slideUp(250).prev().removeClass('active')
  })
  
  $('.select-variants').click(function (e) {
    e.stopPropagation()
  })
  // create fake select variant

  //toggle Specifications tab
  $(".tablinks").click(function(){
    let dataId = $(this).attr("data-id");
    $(".tablinks").removeClass('active');
    $(this).addClass("active");
    $('#' + dataId).addClass("active").css('position','absolute').delay(400).animate({opacity: "1"}).css('position','relative');
    $('#' + dataId).siblings().removeClass("active").css('position','relative').animate({opacity: "0"}).delay(400).css('position','absolute');
    $('.specification .tab-content').animate({height: $('#' + dataId+'.active').outerHeight()+"px"});
  })
  if ($(".product-page .qtyBox input")) {
    document.addEventListener("keyup", function () {
      if ($(".qtyBox input").val() <= 0) {
        $(".cartButton").attr("disabled", "true");
      } else {
        $(".cartButton").removeAttr("disabled");
      }
    });
  }
  //   $('.product-page .jdgm-preview-badge').on('click', function(event){
  //     event.preventDefault();
  //     var marginTop= $('.jdgm-rev-widg').css('margin-top').replace('px','');
  //     var heightHeader= $('.header_container').outerHeight();
  //     setTimeout(function(){
  //       $("html,body").animate({"scrollTop": $("#judgeme_product_reviews").offset().top - heightHeader - marginTop},400);
  //     },1000)
  //   })

  $(".section-product-tab .heading").click(function () {
    $(this).siblings(".content").slideToggle();
    $(this).toggleClass("active");
    $(this).parent().siblings().children(".content").slideUp();
    $(this).parent().siblings().children(".heading").removeClass("active");
  });

  titleTab();
  $(window).resize(function () {
    titleTab();
  });
  $(".product-form__input select").click(function () {
    $(this).toggleClass("open");
  });
  $(document).mouseup(function (e) {
    if ($(".product-form__input select").length) {
      var container = $(".product-form__input select");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".product-form__input select").removeClass("open");
      }
    }
  });
  function titleTab() {
    if ($(".section-product-tab .title").lenghth) {
      $(".section-product-tab .title").each(function () {
        var hTitle = $(this).height();
        var lhTitle = $(this).css("line-height").replace("px", "");
        if (hTitle > 1.5 * lhTitle) {
          $(this).siblings("img").css("margin-top", "8px");
        } else {
          $(this).siblings("img").css("margin-top", "0");
        }
      });
    }
  }
  $(".product-video-second .imgOverlay").click(function () {
    $(this).siblings("iframe").css("z-index", "1");
  });
  if ($(".logo-list")) {
    $(".logo-list .list").addClass("swiper-wrapper");
    $(".logo-list .list  .item").addClass("swiper-slide");
    $(".logo-list").addClass("swiper-logo");
    var swiperLogo = new Swiper(".swiper-logo", {
      spaceBetween: 0,
      //       centeredSlides: true,
      speed: 8000,
      autoplay: {
        delay: 1,
      },
      freeMode: true,
      loop: true,
      slidesPerView: "auto",
      allowTouchMove: true,
      disableOnInteraction: false,
      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 20,
          speed: 4000,
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 20,
          speed: 4000,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 10,
          speed: 8000,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 10,
          speed: 8000,
        },
        1305: {
          slidesPerView: 9,
          spaceBetween: 10,
          speed: 8000,
        },
      },
    });
    swiperLogo.on("touchEnd", function () {
      swiperLogo.slideToClosest(400, false);
      setTimeout(function () {
        swiperLogo.autoplay.start();
      }, 400);
    });
    //     $('.logo-list .list').addClass('owl-carousel');
    //     var owl = $('.owl-carousel');
    //     owl.owlCarousel({
    //       items: 8,
    //       loop: true,
    //       margin: 20,
    //       autoplay: true,
    //       slideTransition: 'linear',
    //       autoplayTimeout: 0,
    //       autoplaySpeed: 8000,
    //       autoplayHoverPause: true

    //     });
  }
  if ($(".lab-developed").lenghth) {
    $(".lab-developed .list").addClass("swiper-wrapper");
    $(".lab-developed .list  .item").addClass("swiper-slide");
    $(".lab-developed .container").addClass("swiper-paragraph");
    var swiper = new Swiper(".swiper-paragraph", {
      slidesPerView: 9,
      spaceBetween: 10,
      allowTouchMove: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        850: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  }
  if ($(".what-people-say").lenghth) {
    $(".what-people-say .jdgm-all-reviews__body").addClass("swiper-wrapper");
    $(".what-people-say .box .jdgm-rev").addClass("swiper-slide");
    $(".what-people-say .jdgm-widget.jdgm-widget").addClass("swiper-reviews");
    var swiper = new Swiper(".swiper-reviews", {
      slidesPerView: 9,
      spaceBetween: 10,
      allowTouchMove: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        900: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  }
  function tabWidth() {
    if ($(".product-tab-left").lenghth) {
      var maxWidth = 1440;
      var padding = 20;
      var prtitle = $(".product-tab-left")
        .css("padding-right")
        .replace("px", "");
      if ($(window).width() > maxWidth) {
        var left = ($(window).width() - maxWidth) / 2;
        $(".product-tab-left .item").width(
          $(window).width() -
            left -
            $(".product-tab-right").width() -
            padding * 2 -
            prtitle
        );
      } else {
        $(".product-tab-left .item").width("unset");
      }
    }
  }
  tabWidth();
  $(window).resize(function () {
    tabWidth();
  });

  if ($('.slider-media').length){
    var galleryBottom = new Swiper(".slider-media-thumbnail", {
        spaceBetween: 7,
        slidesPerView: 6,
        freeMode: true
    });
    
    var galleryTop = new Swiper(".slider-media", {
      spaceBetween: 10,
      // pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      navigation: {
        enabled: false
      },
      // loop: true,
      // loopedSlides: 4,
      thumbs: {
        swiper: galleryBottom,
      },
    });

    $('.slider-media .swiper-pagination-wrapper .prev').click(function(){
        galleryTop.slidePrev();
    });
    $('.slider-media .swiper-pagination-wrapper .next').click(function(){
        galleryTop.slideNext();
    });
    
    

    if (typeof galleryThumbs != 'undefined'){
      galleryTop.controller.control = galleryThumbs;
      galleryThumbs.controller.control = galleryTop;
      if ($(".t-product")) {
        var url_string = window.location.href;
        var url = new URL(url_string);
        var variant = url.searchParams.get("variant");
        $(".product-form__input option").each(function () {
          if ($(this).attr("data-id") == variant) {
            $(this).attr("selected", true);
          }
        });
        $(document).on("change", ".product-form__input select", function () {
          console.log(jQuery(this).val());
          console.log(123);
          var value = $(this).val();
          $(this)
            .find("option")
            .each(function () {
              if ($(this).val() == value) {
                var img_url = $(this).attr("data-img");
                $(".swiper-slide[data-swiper-slide-index=0] img")
                  .attr("src", img_url)
                  .attr("srcset", img_url)
                  .click();
                if ($("swiper-slide-active").attr("data-swiper-slide-index") != 0) {
                  var i = $(".swiper-slide[data-swiper-slide-index=0]").index();
                  galleryThumbs.slideTo(i, 500, false);
                }
              }
            });
        });
      }
    }
  }

  if ($('.meet-the-team_section')){
    $(".meet-the-team_section .image-slider-wrapper").addClass("swiper-wrapper");
    $(".meet-the-team_section .image-slider-wrapper .image-text__item").addClass(
      "swiper-slide"
    );
    $(".meet-the-team_section .right-column").addClass("swiper-team");
    var swiper = new Swiper(".swiper-team", {
      slidesPerView: 10,
      spaceBetween: 10,
      allowTouchMove: true,
      centeredSlides: true,
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        850: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 50,
          centeredSlides: true,
        },
      },
    });
  }

  if ($('.review-slider')){
    $(".review-slider .image-slider-wrapper").addClass("swiper-wrapper");
    $(".review-slider .image-slider-wrapper .image-text__item").addClass(
      "swiper-slide"
    );
    $(".review-slider .right-column").addClass("swiper-team");
    var swiper = new Swiper(".swiper-team", {
      slidesPerView: 2.55,
      spaceBetween: 52,
      allowTouchMove: true,
      //centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: ".meet-next",
        prevEl: ".meet-prev",
      },
      pagination: {
        el: ".meet-pagination",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.55,
          spaceBetween: 32,
        },
        /*850: {
          slidesPerView: 3,
          spaceBetween: 32,
        },*/
        1024: {
          slidesPerView: 2.55,
          spaceBetween: 42,
        },
        1440: {
          //slidesPerView: 5,
          spaceBetween: 52,
          // centeredSlides: true,
        },
        1900: {
          //slidesPerView: 4,
          spaceBetween: 52,
          // centeredSlides: true,
        }
      },
      on: {
        afterInit: function (sw) {
           let paginationWidth = jQuery('.meet-pagination').width();
           let bulletWidth = paginationWidth / sw.slides.length;
           jQuery('.meet-pagination .swiper-pagination-bullet').width(bulletWidth);
        },
      },
    });
  }
  
  // show price on add cart button of main form
  if (jQuery('.product-page .item .swatch-options-container .swatch-option.active').length) {
      let selectedPrice = jQuery('.product-page .item .swatch-options-container .swatch-option.active').attr('data-price');
      jQuery('.t-product .product-page .item .meta product-form .cartPriceAdd .dash').show();
      jQuery('.t-product .product-page .item .meta product-form .cartPriceAdd .price').text(selectedPrice);
      jQuery('.t-product .product-page .product-heading .col-right .price').text(selectedPrice);
  }


  if (jQuery(".t-product .header-inner-form-sticky .select-swatch-options").length) {
      jQuery(".t-product .header-inner-form-sticky .select-swatch-options").select2({
          minimumResultsForSearch: Infinity
      });
      jQuery(".t-product .header-inner-form-sticky .select-swatch-options").on('select2:select', function (e) { 
          let selectedId = jQuery(this).select2('data')[0].id;
          if (isTriggerToStickyForm == 0){
              isTriggerToNormalForm = 1;
              jQuery('.product-page .item .swatch-options-container .swatch-option[data-id="'+selectedId+'"]').trigger('click');
              jQuery('.t-product .header-form-sticky .cartButton.is-primary')
              jQuery('.t-product .header-inner-form-sticky form').submit();
              isTriggerToNormalForm = 0;
          }
      });
  }

  var headerFormStickyToggle = 0;
  jQuery('.t-product .header-form-sticky .cartButton.is-primary:not(.one)').click(function(){
      if (jQuery(window).width() <= 575){
          if (headerFormStickyToggle % 2 == 0){
              jQuery(this).addClass('up');
              jQuery(".t-product .header-inner-form-sticky .select-swatch-options").select2('open');
          }else{
              jQuery(this).removeClass('up');
              jQuery(".t-product .header-inner-form-sticky .select-swatch-options").select2('close');
          }
          headerFormStickyToggle++;
          return false;
      }
  })
    
  //Change select option when choose varirant swatch option
  var isTriggerToNormalForm = 0;
  var isTriggerToStickyForm = 0
  jQuery('.main-product-form .swatch-options-container .swatch-option').click(function(){
      jQuery(this).addClass('active').siblings().removeClass('active');
      let selectedValue = jQuery(this).attr('value');
      let selectedId  = jQuery(this).attr('data-id');
      $('.t-product .main-product-form .select__select').val(selectedValue).trigger('change');
      $('.t-product .main-product-form [name=id]').val(selectedId);
    
      if (jQuery(this).closest('.main-product-form').hasClass('header-inner-form-sticky') == true && 
          isTriggerToStickyForm == 0){
          isTriggerToNormalForm = 1;
          jQuery('.product-page .item .swatch-options-container .swatch-option[data-id="'+selectedId+'"]').trigger('click');
          isTriggerToNormalForm = 0;
      }else if (jQuery(this).closest('.main-product-form').hasClass('header-inner-form-sticky') == false && 
          isTriggerToNormalForm == 0) {
          isTriggerToStickyForm = 1;
          jQuery('.t-product .header-inner-form-sticky .swatch-options-container>*[data-id="'+selectedId+'"]').trigger('click');
          if (jQuery(".t-product .header-inner-form-sticky .select-swatch-options").length) {
              jQuery(".t-product .header-inner-form-sticky .select-swatch-options").val(selectedId).trigger('change');
          }
          isTriggerToStickyForm = 0;
      }
  });

  //Change qty by click Plus/Minus button
  jQuery('.t-product .product-page .item quantity-input .plus').click(function(){
        // console.log('plus');
        let oldValue = parseInt(jQuery(this).prev().val());
        let newValue = oldValue + 1;
        jQuery(this).prev().val(newValue).trigger('change');
        jQuery('.t-product .cartButton.is-primary').removeAttr('disabled');
    
        // update subtotal to button Add to cart in main form of product page
        let subtotal;
        if (jQuery('.t-product #buyplatform .swatch-options-container .swatch-option').length){
            subtotal = jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-currency-symbol') + (newValue * parseFloat(jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-price-value')));  
        }else{
            subtotal = jQuery(this).prev().attr('data-currency-symbol') + (newValue * parseFloat(jQuery(this).prev().attr('data-price-value')));  
        }
        jQuery('.t-product #buyplatform .product-form .cartPriceAdd .price').text(subtotal);
  });
  jQuery('.t-product .product-page .item quantity-input .minus').click(function(){
        // console.log('minus');
        let oldValue = parseInt(jQuery(this).next().val());
        let newValue = oldValue - 1;
        if (newValue < 1) {
            newValue = 1;
        }else{
            jQuery('.t-product .cartButton.is-primary').removeAttr('disabled');
        }
        jQuery(this).next().val(newValue).trigger('change');

        // update subtotal to button Add to cart in main form of product page
        let subtotal;
        if (jQuery('.t-product #buyplatform .swatch-options-container .swatch-option').length){
            subtotal = jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-currency-symbol') + (newValue * parseFloat(jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-price-value')));
        }else{
            subtotal = jQuery(this).next().attr('data-currency-symbol') + (newValue * parseFloat(jQuery(this).next().attr('data-price-value')));
        }
        jQuery('.t-product #buyplatform .product-form .cartPriceAdd .price').text(subtotal);
  });


  //Custom site badge reviews
  jQuery('.product-page').on('DOMNodeInserted',function(){
      if (jQuery('[data-widget-type="site-badge"][data-badge-type="minimal"]').length && jQuery('[data-widget-type="site-badge"][data-badge-type="minimal"] .stamped-average-stars').length == 0){
        setTimeout(function(){
            jQuery('[data-widget-type="site-badge"][data-badge-type="minimal"]').each(function(){
              var starAverage = jQuery(this).children().attr('data-rating');
              if(jQuery(this).find('.stamped-average-stars').length){
                jQuery(this).find('.stamped-average-stars').text(starAverage);
              } else {
                jQuery('<span class="stamped-average-stars">'+ starAverage +'</span>').insertAfter(jQuery(this).find('.stamped-badge-stars'));
              }
          });
        }, 1000);
      }
  });

  
    //change price in add to cart button and change image in gallery
    jQuery(document).ajaxComplete(function(){
        if(jQuery('.t-product #buyplatform .product-form .swatch-options-container .swatch-option.active').length){
            let option = jQuery('.t-product #buyplatform .product-form .swatch-options-container .swatch-option.active').attr('data-price');
            if(option.length > 0){
                let priceProductDetail = option;
                jQuery('.t-product #buyplatform .product-form .cartPriceAdd .dash').show();
                let priceValue = parseFloat(jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-price-value'));
                let priceSymbol = jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-currency-symbol');
                let qtyValue = parseInt(jQuery('.t-product #buyplatform .qtyBox input').val());
                let subtotal = priceSymbol + (qtyValue * priceValue);
                jQuery('.t-product #buyplatform .product-form .cartPriceAdd .price').text(subtotal);
            }
        }
    });
    $('.t-product').on('change', '#buyplatform .product-form__input select', function(e) {
        let selectedValue = jQuery(this).val();
        let option = jQuery(this).find('option[value="'+selectedValue+'"]').text().split("-");
        if(option.length > 1){
            let priceProductDetail = option[1].trim();
            jQuery('.t-product #buyplatform .product-form .cartPriceAdd .dash').show();
            let priceValue = parseFloat(jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-price-value'));
            let priceSymbol = jQuery('.t-product #buyplatform .swatch-options-container .swatch-option.active').attr('data-currency-symbol');
            let qtyValue = parseInt(jQuery('.t-product #buyplatform .qtyBox input').val());
            let subtotal = priceSymbol + (qtyValue * priceValue);
            jQuery('.t-product #buyplatform .product-form .cartPriceAdd .price').text(subtotal);
            jQuery('.t-product .product-page .product-heading .col-right .price').text(subtotal)
          
            if ($('.list-variant-media .media-item').length > 1){
                // let variantImageUrl = $('.list-variant-media .media-item[data-price="'+priceProductDetail+'"]').attr('data-image');
                let variantImageUrl = $(this).find('option:selected').attr('data-img');
                // console.log(variantImageUrl);
                if(typeof galleryTop != 'undefined'){
                    let variantImageIndex = $('.product-page .gallery .slider-media .media img[src*="'+variantImageUrl+'"]').closest('.swiper-slide').attr('data-swiper-slide-index');
                    galleryTop.slideTo(variantImageIndex);
                }
            }
        }
    });
    
    if (jQuery('.t-product .header-inner-form-sticky').length && jQuery('.t-product .product-page').length){
        if (elementsOverlap(jQuery('.header-inner-form-sticky'), jQuery('.product-page'))) {
            jQuery('.t-product .header-inner-form-sticky').addClass('hide');
        }else{
            jQuery('.t-product .header-inner-form-sticky').removeClass('hide');
        }
    }
});

jQuery(window).on('change resize orientationchange', function(){
    updateTopProductGallery();
  
    if(jQuery('.specification .tab-content').length){
        jQuery('.specification .tab-content').animate({height: jQuery('.specification .tab-content .active').outerHeight()+"px"});
    } 
});

jQuery(window).scroll(function(){
    if (jQuery('.t-product .header-inner-form-sticky').length && jQuery('.t-product .product-page').length){
        if (elementsOverlap(jQuery('.header-inner-form-sticky'), jQuery('.product-page'))) {
            jQuery('.t-product .header-inner-form-sticky').addClass('hide');
            jQuery('.t-product .header-form-sticky form').addClass('hide');
        }else{
            jQuery('.t-product .header-inner-form-sticky').removeClass('hide');
            jQuery('.t-product .header-form-sticky form').removeClass('hide');
        }
    }
});

